import { render } from "./BmManage.vue?vue&type=template&id=4ea2129d&scoped=true&ts=true"
import script from "./BmManage.vue?vue&type=script&lang=ts"
export * from "./BmManage.vue?vue&type=script&lang=ts"

import "./BmManage.vue?vue&type=style&index=0&id=4ea2129d&scoped=true&lang=css"

import exportComponent from "/Users/zhongyue/Desktop/work/hu-shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea2129d"]])

export default __exports__